import React, { useEffect, useState } from 'react';
import "./FormComponent.css";
import { Button } from './Button';
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from 'react-datepicker';
import { FormProps, Field, FormReturnData } from '../../types/FromComponent.types';


export const FormComponent: React.FC<FormProps> = ({ title, fields, variant = 'default', onSubmit, onChange, button = { name: "Send", disabled: false } }) => {
    const [formData, setFormData] = useState<{ [key: string]: string }>({});
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement> | Date,
        field: Field
    ) => {
        const value = field.type === 'date'
            ? (e as Date).toISOString()
            : (e as React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>).target.value;
        setFormData((prevData) => ({ ...prevData, [field.name]: value }));
    };

    /*const handleAddField = () => {
        const baseField = fields.find((field) => field.autoIncrement); // Prendi un campo con autoIncrement
        if (!baseField) return;

        const newField = {
            ...baseField,
            name: `${baseField.name}_${dynamicFields.length}`, // Nome unico
            placeholder: `${baseField.placeholder} ${dynamicFields.length}`, // Placeholder unico
        };
        setDynamicFields((prevFields) => [...prevFields, newField]);
    };*/

    const validateForm = () => {
        const isValid = fields.every((field) => {
            if (field.optional) return true;
            return formData[field.name] && formData[field.name].trim() !== '';
        });
        setIsButtonDisabled(!isValid);
    };

    const handleSubmit = () => {
        const finalData = Object.keys(formData).reduce((acc, key) => {
            const value = formData[key];
            if (Array.isArray(value)) {
                acc[key] = value;
            } else {
                acc[key] = value || '';
            }
            return acc;
        }, {} as FormReturnData);

        onSubmit(finalData);
    };

    useEffect(() => {
        setFormData((prevData) => {
            const nextData = { ...prevData };
            let hasChanges = false;

            fields.forEach((field) => {
                const currentValue = nextData[field.name];

                if (field.type === 'dropdown') {
                    const options = field.options ?? [];

                    if (options.length === 0) {
                        if (currentValue !== '') {
                            nextData[field.name] = '';
                            hasChanges = true;
                        }
                        return;
                    }

                    if (options.length === 1) {
                        const singleOptionValue = String(options[0].id);
                        if (currentValue !== singleOptionValue) {
                            nextData[field.name] = singleOptionValue;
                            hasChanges = true;
                        }
                        return;
                    }

                    if ((currentValue === undefined || currentValue === '') && field.df !== undefined) {
                        nextData[field.name] = String(field.df);
                        hasChanges = true;
                        return;
                    }

                    if (currentValue !== undefined && currentValue !== '') {
                        const hasValidOption = options.some((option) => String(option.id) === String(currentValue));
                        if (!hasValidOption) {
                            nextData[field.name] = '';
                            hasChanges = true;
                        }
                    }

                    return;
                }

                if ((currentValue === undefined || currentValue === '') && field.df !== undefined) {
                    nextData[field.name] = String(field.df);
                    hasChanges = true;
                }
            });

            return hasChanges ? nextData : prevData;
        });
    }, [fields]);


    useEffect(() => { 
        validateForm();
        if (onChange) {
            const finalData = Object.keys(formData).reduce((acc, key) => {
                acc[key] = formData[key] || ''; // Default to empty string if undefined
                return acc;
            }, {} as FormReturnData);            
            onChange(finalData);
        }
    }, [formData]);

    return (
        <div className={`form-container ${variant === 'left' ? 'form-container--left' : ''}`}>
            <h2 className="form-title">{title}</h2>
            {fields.map((field, index) => (
                <div key={index} className={`form-group ${field.type === 'textarea' ? 'form-group--stacked' : ''}`}>
                    {field.type !== "hidden" && <label htmlFor={field.name}>{field.placeholder}</label>}
                    {field.type === 'dropdown' && field.options ? (
                        (() => {
                            const options = field.options ?? [];
                            const hasNoOptions = options.length === 0;
                            const hasSingleOption = options.length === 1;
                            const selectedValue = formData[field.name] ?? '';

                            return (
                                <select
                                    name={field.name}
                                    id={field.name}
                                    value={selectedValue}
                                    onChange={(e) => handleChange(e, field)}
                                    className="form-select"
                                    disabled={hasNoOptions || hasSingleOption}
                                >
                                    {hasNoOptions ? (
                                        <option value="" disabled>
                                            No options available
                                        </option>
                                    ) : (
                                        <option value="" disabled>
                                            Select an option
                                        </option>
                                    )}
                                    {options.map((option, idx) => (
                                        <option key={idx} value={option.id}>
                                            {option.value}
                                        </option>
                                    ))}
                                </select>
                            );
                        })()
                    ) : field.type === 'date' ? (
                        <ReactDatePicker
                            selected={formData[field.name] ? new Date(formData[field.name]) : null}
                            onChange={(date) => handleChange(date as Date, field)}
                            dateFormat="yyyy-MM-dd"
                            className="form-input"
                        />
                    ) : field.type === 'textarea' ? (
                        <textarea
                            name={field.name}
                            id={field.name}
                            placeholder={field.placeholder}
                            value={formData[field.name] || ''}
                            onChange={(e) => handleChange(e, field)}
                            className="form-input form-textarea"
                        />
                    ) : (
                        <input
                            type={field.type}
                            name={field.name}
                            id={field.name}
                            placeholder={field.placeholder}
                            value={formData[field.name] || ''}
                            onChange={(e) => handleChange(e, field)}
                            className="form-input"
                        />
                    )}
                </div>
            ))}
            <div className="buttons-send">
                <Button name={button.name} action={handleSubmit} disabled={button.disabled || isButtonDisabled} />
            </div>
        </div>
    );

    /*return (
        <div className="form-container">
            <h2 className="form-title">{title}</h2>
            {dynamicFields.map((field, index) => (
                <div key={index} className="form-group">
                    <label htmlFor={field.name}>{field.placeholder}</label>
                    {field.type === 'dropdown' && field.options ? (
                        <select
                            name={field.name}
                            id={field.name}
                            value={formData[field.name] || ''}
                            onChange={(e) => handleChange(e, field, index)}
                            className="form-select"
                        >
                            <option value="" disabled>
                                Select an option
                            </option>
                            {field.options.map((option, idx) => (
                                <option key={idx} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    ) : (
                        <input
                            type={field.type}
                            name={field.name}
                            id={field.name}
                            placeholder={field.placeholder}
                            value={formData[field.name] || ''}
                            onChange={(e) => handleChange(e, field, index)}
                            className="form-input"
                        />
                    )}
                    {index > 0 && (
                        <Button name={<FontAwesomeIcon icon={faMinus} />} action={() => handleRemoveField(index)} color='red' />
                    )}

                </div>
            ))}
            <div className="form-group">
                <Button name="Send" action={handleSubmit} />
                <Button name={<FontAwesomeIcon icon={faPlus} />} action={() => handleAddField()} />
            </div>
        </div>
    );*/
};
